import { render, staticRenderFns } from "./RevisePedido.vue?vue&type=template&id=e861f808&scoped=true"
import script from "./RevisePedido.vue?vue&type=script&lang=js"
export * from "./RevisePedido.vue?vue&type=script&lang=js"
import style0 from "./RevisePedido.vue?vue&type=style&index=0&id=e861f808&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e861f808",
  null
  
)

export default component.exports